exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkAceite strong {\n  display: flex;\n  font-size: 18pt;\n  margin-left: 50px;\n  margin-top: -20px; }\n", ""]);

// exports
